
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"39","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.935 10.735C38.366 4.515 33.931 0 28.381 0c-3.698 0-7.084 1.975-8.989 5.142C17.504 1.935 14.258 0 10.62 0 5.069 0 .634 4.513.065 10.734c-.045.275-.23 1.721.332 4.08.808 3.4 2.676 6.495 5.4 8.945L19.382 36l13.82-12.24c2.724-2.451 4.592-5.544 5.4-8.947.561-2.357.377-3.803.332-4.078z","fill":"#006733"}})])
          )
        }
      }
    